import React from 'react'
import { Link } from 'react-router-dom'

export default function PendingPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="text-6xl mb-6">⏳</div>
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Account Pending Approval</h1>
        <p className="text-gray-600 mb-8 max-w-md">
          Your account is pending approval. Your admin has been notified and will review your request shortly.
        </p>
        <Link to="/login" className="text-blue-600 hover:underline font-medium">Back to Login</Link>
      </div>
    </div>
  )
}